/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    talkerName: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    profileImagePath?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Comment
     */
    commentImagePaths?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    talkerId: string;
}

/**
 * Check if a given object implements the Comment interface.
 */
export function instanceOfComment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "talkerName" in value;
    isInstance = isInstance && "talkerId" in value;

    return isInstance;
}

export function CommentFromJSON(json: any): Comment {
    return CommentFromJSONTyped(json, false);
}

export function CommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Comment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'],
        'createdAt': json['createdAt'],
        'talkerName': json['talkerName'],
        'profileImagePath': !exists(json, 'profileImagePath') ? undefined : json['profileImagePath'],
        'commentImagePaths': !exists(json, 'commentImagePaths') ? undefined : json['commentImagePaths'],
        'talkerId': json['talkerId'],
    };
}

export function CommentToJSON(value?: Comment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'text': value.text,
        'createdAt': value.createdAt,
        'talkerName': value.talkerName,
        'profileImagePath': value.profileImagePath,
        'commentImagePaths': value.commentImagePaths,
        'talkerId': value.talkerId,
    };
}

